import React, { useCallback, useEffect, useState } from 'react'

interface ScrollValue {
    scrollY: number
}

export const ScrollContext = React.createContext<ScrollValue>({
    scrollY: 0
})
type ScrollProps = {
    children: React.ReactNode; //👈 children prop typr
};

const ScrollObserver: React.FC<ScrollProps> = (props: ScrollProps) => {
    const [scrollY, setScrollY] = useState(0)
    const handleScroll = useCallback(() => {
        setScrollY(window.scrollY)
    }, [])

    useEffect(() => {
        document.addEventListener('scroll', handleScroll, { passive: true })
        return () => document.removeEventListener('scroll', handleScroll)
    }, [handleScroll])
    return (
        <ScrollContext.Provider value={{ scrollY }}>
            {props.children}
        </ScrollContext.Provider>
    )
}

export default ScrollObserver
